const eventStatusOptions = [
  // { label: 'Open', value: '1' },
  // { label: 'Close', value: '2' },
  // { label: 'Fact Finding', value: '3' },
  // { label: 'Policy Review', value: '4' },
  // { label: 'Meal Appointment', value: '5' },
  // { label: 'Recruitment', value: '6' },
  // { label: 'Follow Up', value: '7' },
  // { label: 'None/Service', value: '0' },

  { label: 'Sales - Meal Appointment', value: '5' },
  { label: 'Sales - Open', value: '1' },
  { label: 'Sales - Closing', value: '2' },
  { label: 'Sales - Services', value: '8' },
  { label: 'Sales - Fact Finding', value: '3' },
  { label: 'Sales - Policy Review', value: '4' },
  { label: 'Sales - Follow Up', value: '7' },
  { label: 'Recruitment - Fact Finding', value: '6' },
  { label: 'Recruitment - Interview', value: '9' },
  { label: 'Recruitment - Follow Up', value: '10' },
  { label: 'Recruitment - Contract', value: '11' },
  { label: 'Recruitment - Meal Appointment', value: '13' },
  { label: 'Personal', value: '0' },
  { label: 'Non Face To Face', value: '12' },
  { label: 'Prospect', value: '14' },
];

const repeatOptions = [
  { label: 'Never', value: 'NONE' },
  { label: 'Every Day', value: 'DAY' },
  { label: 'Every Week', value: 'WEEK' },
  { label: 'Every Month', value: 'MONTH' },
  { label: 'Every Year', value: 'YEAR' },
  { label: 'Custom', value: 'CUSTOM' },
];
// Old colors
// const colorOptions = [
//   '#00a0c5', //blue
//   '#ff4444', //red
//   '#d29200', //brown
//   //'#f5b945', //yellow
//   '#32b100', //green
//   '#8300e6', //purple
//   '#00a18d', //cyan
//   '#990060', //dark pink
// ];

// Old colors
// const colorOptions = [
//   '#1e88e5', //blue
//   '#e53935', //red
//   '#fdd835', //brown
//   //'#f5b945', //yellow
//   '#43a047', //green
//   '#8e24aa', //purple
//   '#00897b', //cyan
//   '#e91e63', //dark pink
// ];

const colorOptions = [
  '#1e88e5', //blue
  '#b71c1c', //red
  '#ff8f00', //orange
  '#5d4037', //brown
  '#388e3c', //green
  '#8e24aa', //purple
  '#eb0089', //pink
];

const repeatPeriodOptions = [
  { label: 'Day', value: 'DAY' },
  { label: 'Week', value: 'WEEK' },
  { label: 'Month', value: 'MONTH' },
  { label: 'Year', value: 'YEAR' },
];

const appointmentCountOptions = [
  { label: 'None', value: 'NONE' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
];

const getEventStatusText = statusID => {
  const IDs = eventStatusOptions.map(e => e.value);
  const index = IDs.indexOf(statusID);
  if (index === -1) return '';
  return eventStatusOptions[index].label;
};

const mapEventStatusIDToText = (rawStatus = '') => {
  const status = String(rawStatus).split(',').sort();
  return status.map(getEventStatusText).join(', ');
};

export {
  eventStatusOptions,
  repeatOptions,
  colorOptions,
  repeatPeriodOptions,
  getEventStatusText,
  mapEventStatusIDToText,
  appointmentCountOptions,
};
